import { Box, IconButton, Text } from "@chakra-ui/react";
import React, { useEffect, useMemo, useState } from "react";
import { RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { openCreateLectureModel } from "../../../modules/admin-modules/models/Actions";
import dayjs from "dayjs";
import { brandPalette } from "../../../constants/brandPalette";

const LecturesTable = ({ setAdd, setSelectedData, searchTerm = "" }) => {
  const lectures = useSelector((state) => state.lectures.lectures);
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.lectures.isLoading);
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const filteredLectures = useMemo(() => {
    const list = Array.isArray(lectures) ? lectures : [];
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return list;
    return list.filter((row) => row?.title?.toLowerCase().includes(q));
  }, [lectures, searchTerm]);

  useEffect(() => {
    setPageNumber(0);
  }, [searchTerm]);

  const viewData = (row) => {
    const plain = filteredLectures.find((l) => l.id === row?.id);
    const payload = plain || row;
    setSelectedData(payload);
  };

  const Data = filteredLectures.map((data) => {
    return {
      ...data,
      id: data?.id,
      title: data?.title,
      edit: (
        <IconButton
          variant="ghost"
          aria-label="Edit center"
          fontSize="20px"
          color={brandPalette.primary}
          _hover={{ bg: "rgba(91, 13, 22, 0.08)", color: brandPalette.accentDark }}
          icon={<RiFileEditLine />}
          onClick={(e) => {
            e.stopPropagation();
            setAdd(false);
            setSelectedData(data);
            dispatch(openCreateLectureModel());
          }}
        />
      ),
    };
  });

  const columns = [
    {
      Header: "Center name",
      accessor: "title",
    },
    {
      Header: "Actions",
      accessor: "edit",
    },
  ];

  const totalPage = Math.ceil(filteredLectures.length / size) || 0;

  return (
    <Box px={{ base: 4, md: 8 }} pb={10} w="100%">
      <Box
        bg="rgba(255,255,255,0.9)"
        border="1px solid"
        borderColor={brandPalette.stone}
        borderRadius="16px"
        overflow="hidden"
        boxShadow="sm"
      >
        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path={"openModel"}
          Actions
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={isLoading}
          perPage={size}
          totalPage={totalPage}
          wrapperProps={{ maxH: "unset", overflow: "auto" }}
          tableProps={{ bg: "transparent", borderRadius: "0", mb: 0 }}
          theadProps={{ bg: brandPalette.stone, color: brandPalette.accentDark }}
        />
      </Box>
    </Box>
  );
};

export default LecturesTable;
